import { Link } from 'react-router-dom'
import { LandingNav, PricingSection } from '@/components/landing'

export function LandingPage() {
  return (
    <div className="min-h-screen bg-primary-bg">
      <LandingNav />

      {/* Hero */}
      <section className="py-24 px-4">
        <div className="max-w-3xl mx-auto text-center">
          <h1 className="text-5xl sm:text-6xl font-medium tracking-tight">
            Your posts, but better.
          </h1>
          <p className="mt-6 text-lg text-secondary-text max-w-xl mx-auto">
            Beacon learns your voice, generates content that sounds like you,
            and posts it while you touch grass.
          </p>
          <p className="mt-4 text-sm text-secondary-text">
            15 free generations. No credit card.
          </p>
          <div className="mt-8 flex items-center justify-center gap-4">
            <Link to="/login?tab=register" className="btn btn-primary">
              Start free
            </Link>
            <a
              href="#pricing"
              className="btn btn-secondary"
            >
              See pricing
            </a>
          </div>
        </div>
      </section>

      {/* Demo / Preview */}
      <section className="py-16 px-4">
        <div className="max-w-4xl mx-auto">
          <div className="aspect-video bg-gradient-to-br from-secondary-bg to-gray-200 border border-border flex items-center justify-center">
            <span className="text-secondary-text text-sm">Product preview</span>
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="py-20 px-4">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-3xl font-medium text-center mb-16">
            How it works
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="border border-border p-6">
              <h3 className="text-lg font-medium mb-2">
                Writes like you, not like a robot
              </h3>
              <p className="text-secondary-text text-sm">
                Beacon analyzes your existing posts to learn your voice, tone,
                and style. Every piece of content it generates sounds like
                something you'd actually post.
              </p>
            </div>
            <div className="border border-border p-6">
              <h3 className="text-lg font-medium mb-2">
                Generate. Edit. Approve. Post. Done.
              </h3>
              <p className="text-secondary-text text-sm">
                Give Beacon a topic or let it suggest ideas. Review and edit
                drafts in your queue, then post directly to X with one
                click.
              </p>
            </div>
            <div className="border border-border p-6">
              <h3 className="text-lg font-medium mb-2">
                Set it. Forget it. Go outside.
              </h3>
              <p className="text-secondary-text text-sm">
                Schedule posts in advance and let auto-posting handle the rest.
                Stay consistent without being glued to your phone.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Pricing */}
      <PricingSection />

      {/* Footer CTA */}
      <section className="py-20 px-4 border-t border-border">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="text-3xl font-medium mb-4">
            Ready to stop overthinking every post?
          </h2>
          <Link to="/login?tab=register" className="btn btn-primary mt-6 inline-block">
            Start free
          </Link>
        </div>
      </section>

      {/* Footer */}
      <footer className="border-t border-border py-8 px-4">
        <div className="max-w-6xl mx-auto flex items-center justify-between">
          <span className="text-sm text-secondary-text">Beacon</span>
          <div className="flex items-center gap-6">
            <Link
              to="/pricing"
              className="text-sm text-secondary-text hover:text-primary-text transition-colors"
            >
              Pricing
            </Link>
            <Link
              to="/blog"
              className="text-sm text-secondary-text hover:text-primary-text transition-colors"
            >
              Blog
            </Link>
            <Link
              to="/terms"
              className="text-sm text-secondary-text hover:text-primary-text transition-colors"
            >
              Terms
            </Link>
            <Link
              to="/privacy"
              className="text-sm text-secondary-text hover:text-primary-text transition-colors"
            >
              Privacy
            </Link>
            <Link
              to="/login"
              className="text-sm text-secondary-text hover:text-primary-text transition-colors"
            >
              Login
            </Link>
          </div>
        </div>
      </footer>
    </div>
  )
}
